/* eslint-disable react/prop-types */
import * as React from 'react';

import { translate } from '~l10n/client';
import _ from 'underscore';

import Select from '../../../../shared/components/elements/Select';

const SUBJECT_MATH = 1;
const SUBJECT_SCIENCE = 2;
const SUBJECT_LANGUAGE_ARTS = 3;
const SUBJECT_SOCIAL_STUDIES = 4;

let c = null;

class NoAPIAccessError extends React.Component {
  render() {
    return (
      <div
        key="noAPIAccessError"
        className="standard-container standards-no-access"
      >
        <span key="infoIcon" className="info-icon" data-icon="z" />
        <span key="noAPIAccessSpan">
          <strong key="noAPIStrong">
            {translate('Standards are currently unavailable.')}
          </strong>
          {translate(
            'Check back later or add a question to continue without standards.'
          )}
        </span>
      </div>
    );
  }
}

class StandardView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayDescription: false,
    };
  }

  render() {
    let standardDescription = this.props.standard['short_description'];
    let showEditDeleteButtons = this.props.isNewQuizEditor ? null : (
      <div className="standard-buttons">
        <button
          key="editStandardButton"
          className="standard-change-button"
          onClick={c.editStandardClicked}
        >
          <i data-icon="C" />
          {translate('Change')}
        </button>
        <button
          key="deleteStandardButton"
          className="standard-delete-button"
          onClick={c.deleteStandardClicked}
        >
          <i data-icon="L" />
          {translate('Delete')}
        </button>
        <button
          className="standard-show-description-button"
          onClick={() => {
            this.setState({
              displayDescription: !this.state.displayDescription,
            });
          }}
        >
          <i data-icon={!this.state.displayDescription ? 'E' : 'F'} />
        </button>
      </div>
    );
    let standardStyle = this.props.isNewQuizEditor
      ? 'flex flex-wrap md:flex-no-wrap'
      : '';
    return (
      <div className="standard-name-container">
        <div key="standardDescription" className={standardStyle}>
          <strong key="standardName" className="standard-name">
            {this.props.standard['name']}
          </strong>
          <span
            key="standardDescription"
            className="standard-description"
            dangerouslySetInnerHTML={{ __html: standardDescription }}
          />
          {showEditDeleteButtons}
        </div>
        <p
          key="secondStandardDescription"
          className={
            'second-standard-description' +
            (!this.state.displayDescription ? ' old-hidden' : '')
          }
          dangerouslySetInnerHTML={{ __html: standardDescription }}
        />
      </div>
    );
  }
}

class StandardList extends React.Component {
  /**
   * When the standard is created from the blueprint, each of its child objects is null. In this case the loader
   * should not be displayed. After a selection is made, the next option value becomes an empty array, meaning
   * it is waiting for a list of values. In this case the loader should be displayed until the option receives
   * its values.
   * @param {string} name The name of the option
   * @returns {boolean} true if the loader should be shown, false otherwise
   */
  shouldShowLoadingIndicator(name) {
    let obj = this.props.standard.standardsObject[name];
    return _.isNull(obj) ? false : _.isEmpty(obj);
  }

  shouldBeDisabled(name) {
    return _.isNull(this.props.standard.standardsObject[name]);
  }

  createSubjectList(isNewComponent) {
    let newStandard = this.props.standard;
    let standardsObject = newStandard.standardsObject;

    let subjectList = {
      id: 'subject-select',
      name: 'subject',
      key: 'subjectList',
      label: translate('Subject'),
      onSelect: (changed, newValue) => c.standardChanged(changed, newValue),
      children: [],
      isNewComponent: isNewComponent,
    };

    _.each(standardsObject['subject'], function (value) {
      subjectList.children.push({
        value: value['id'],
        key: value['name'],
        selected: newStandard['subject'] && value.id === newStandard['subject'],
        selectable: true,
        title: value['name'],
        isNewComponent: isNewComponent,
      });
    });

    return subjectList;
  }

  createCoreList(isNewComponent) {
    let newStandard = this.props.standard;
    let standardsObject = newStandard.standardsObject;
    let customList = [];
    let coreList = {
      id: 'core-select',
      name: 'core',
      key: 'coreList',
      label: translate('Select Core'),
      loading: this.shouldShowLoadingIndicator('core'),
      disabled: this.shouldBeDisabled('core'),
      opened: standardsObject.noResponseData === 'core',
      onSelect: (changed, newValue) => c.standardChanged(changed, newValue),
      children: [],
      isNewComponent: isNewComponent,
    };

    if (newStandard['subject']) {
      let states = _.keys(standardsObject['core']);
      states.sort();

      _.each(states, (state) => {
        let value = standardsObject['core'][state];
        let options = [];

        _.each(value, (core) => {
          options.push({
            title: core['name'],
            value: core['id'],
            key: core['name'],
            selectable: true,
            selected:
              newStandard['core'] && core['id'] === String(newStandard['core']),
            isNewComponent: isNewComponent,
          });
        });

        let listTitleEl = {
          title: state,
          selectable: false,
          children: options,
        };

        if (state === 'Common') {
          customList.push(listTitleEl);
        } else if (state === 'Custom') {
          // Ignore custom cores for now.
        } else {
          coreList.children.push(listTitleEl);
        }
      });

      /**
       * After creating the common list of standards, we need them in a special order deppending on the subject.
       * Check to see if the list is empty. It's empty when the MC API is called and we're waiting for a response.
       */
      if (!_.isEmpty(customList)) {
        let sortCores = function (cores, coreIds) {
          try {
            let finalArray = [];
            let arr = cores;

            // Go through each coreid and group the common core list into two lists.
            // The first one will have our core which will be added to the new array in our desired position
            // The second half will have the rest of the cores.
            // If necessary go through the remaining list of cores again.
            _.each(coreIds, function (coreid) {
              let good = _.groupBy(arr, function (core) {
                return String(core['value']) === coreid;
              });

              if (good['true']) {
                finalArray.push(good['true'][0]);
              }

              arr = good['false'];
            });

            // If there are cores left, just add them to the end. The order here doesn't matter.
            if (_.isArray(arr)) {
              finalArray = finalArray.concat(arr);
            }

            return finalArray;
          } catch (error) {
            console.warn('Error reordering cores:', error);
            return cores;
          }
        };

        if (newStandard['subject'] === SUBJECT_MATH) {
          /**
           * the common core should have the following order
           * 4        - Traditional
           * 6        - Integrated
           * 1774     - Spanish: Matematicas (2014)
           * 596      - High School Standards by Domain
           */
          customList[0].children = sortCores(customList[0].children, [
            '4',
            '6',
            '1774',
            '596',
          ]);
        } else if (newStandard['subject'] === SUBJECT_SCIENCE) {
          /**
           * the common core should have the following order
           * 143  - Science and Technical Studies
           * 1773 - Lecto-escritura para Ciencias y Materias Técnicas (2013)
           */
          customList[0].children = sortCores(customList[0].children, [
            '143',
            '1773',
          ]);
        } else if (newStandard['subject'] === SUBJECT_LANGUAGE_ARTS) {
          /**
           * the common core should have the following order
           * 5        - Language Arts
           * 1752     - Artes del Lenguaje en Español (2013)
           */
          customList[0].children = sortCores(customList[0].children, [
            '5',
            '1752',
          ]);
        } else if (newStandard['subject'] === SUBJECT_SOCIAL_STUDIES) {
          /**
           * the common core should have the following order
           * 142      - History/Social Studies
           * 1772     - Lecto-escritura en Historia y Estudios Sociales (2013)
           */
          customList[0].children = sortCores(customList[0].children, [
            '142',
            '1772',
          ]);
        }
      }

      coreList.children = _.union(customList, coreList.children);
    }

    return coreList;
  }

  createGradeList(isNewComponent) {
    let newStandard = this.props.standard;
    let standardsObject = newStandard.standardsObject;

    let classList = {
      id: 'grade-select',
      name: 'class',
      key: 'gradeList',
      label: translate('Select Class/Grade'),
      loading: this.shouldShowLoadingIndicator('class'),
      disabled: this.shouldBeDisabled('class'),
      opened: standardsObject.noResponseData === 'class',
      onSelect: (changed, newValue) => c.standardChanged(changed, newValue),
      children: [],
      isNewComponent: isNewComponent,
    };

    if (newStandard['core']) {
      _.each(standardsObject['class'], function (value) {
        classList.children.push({
          value: value['class_objective']['id'],
          title: value['class_objective']['name'],
          key: value['class_objective']['name'],
          selectable: true,
          selected:
            newStandard['class'] &&
            value['class_objective']['id'] === String(newStandard['class']),
        });
      });
    }

    return classList;
  }

  createStandardsList(isNewComponent) {
    let newStandard = this.props.standard;
    let standardsObject = newStandard.standardsObject;

    let standardsList = {
      id: 'standard-select',
      name: 'standard',
      key: 'standardList',
      label: translate('Select Standard'),
      loading: this.shouldShowLoadingIndicator('standard'),
      disabled: this.shouldBeDisabled('standard'),
      opened: standardsObject.noResponseData === 'standard',
      onSelect: (changed, newValue) => c.standardChanged(changed, newValue),
      children: [],
      isNewComponent: isNewComponent,
    };

    if (newStandard['class']) {
      _.each(standardsObject['standard'], function (value) {
        standardsList.children.push({
          title: String(value['name']).toUpperCase(),
          value: value['id'],
          key: String(value['name']),
          description: value['short_description'],
          selectable: true,
          selected:
            newStandard['standard'] &&
            value['id'] === String(newStandard['standard']['id']),
        });
      });
    }

    if (standardsList.children.length < 1) {
      standardsList.disabled = true;
    }

    return standardsList;
  }

  render() {
    let newStandard = this.props.standard;
    let subjectList = this.createSubjectList(this.props.isNewQuizEditor);
    let coreList = this.createCoreList(this.props.isNewQuizEditor);
    let classList = this.createGradeList(this.props.isNewQuizEditor);
    let standardsList = this.createStandardsList(this.props.isNewQuizEditor);
    let standardsListItems = [
      <li key="subjectList">
        <p key="subjectTitle" className="cores-title">
          {translate('Subject')}
        </p>
        <Select {...subjectList} />
      </li>,
      <li key="coresList" className={coreList.disabled ? 'disabled-list' : ''}>
        <p key="coresTitle" className="cores-title">
          {translate('Core')}
        </p>
        <Select {...coreList} />
      </li>,
      <li
        key="class/gradeList"
        className={classList.disabled ? 'disabled-list' : ''}
      >
        <p key="class/gradeTitle" className="cores-title">
          {translate('Class/Grade')}
        </p>
        <Select {...classList} />
      </li>,
      <li
        key="standardList"
        className={standardsList.disabled ? 'disabled-list' : ''}
      >
        <p key="standard-title" className="cores-title">
          {translate('Standard')}
        </p>
        <Select {...standardsList} />
      </li>,
    ];

    if (!this.props.isNewQuizEditor) {
      standardsListItems.push(
        <li
          key="legacyButtonLayout"
          style={{
            // If the standard is complete but dirty, it is in edit mode. In this case, show the buttons.
            display:
              !newStandard.complete && newStandard.dirty ? 'none' : 'block',
          }}
        >
          <button
            className="button button-primary button-small"
            onClick={() => c.standardChanged('save', null)}
          >
            {translate('Save')}
          </button>
          <button
            className="button button-link standards-cancel-button"
            onClick={c.cancelEditStandardClicked}
          >
            {translate('Cancel')}
          </button>
        </li>
      );
    }

    let standardsListStyle = this.props.isNewQuizEditor ? 'standards-list' : '';
    return (
      <ul
        className={standardsListStyle}
        style={
          this.props.isNewQuizEditor
            ? {}
            : { display: this.props.standard ? 'block' : 'none' }
        }
      >
        {standardsListItems}
      </ul>
    );
  }
}

export default class Standards extends React.Component {
  render() {
    c = this.props.controller;

    let standard = this.props.standard;

    // We have a special flag set when we have an API problem. Simply remove all options.
    if (standard && standard.noAccess === true) {
      return <NoAPIAccessError />;
    }

    // If the quiz has a complete standard attached to it, display that.
    let showStandardView =
      !this.props.hideCompletedStandard &&
      standard &&
      standard.complete === true &&
      standard.dirty !== true;
    if (showStandardView) {
      return (
        <StandardView
          isNewQuizEditor={this.props.isNewQuizEditor}
          standard={standard['standard']}
        />
      );
    }

    // If the quiz has an empty standard attached, the user wants to attach one. In this case show the drop downs.
    let newStandard = null;
    let newStandardProp = Object.assign({}, this.props, {
      key: 'standardProps',
    });
    if (this.props.standard) {
      newStandard = <StandardList {...newStandardProp} />;
    }

    let renderLegacyCheckbox = this.props.isNewQuizEditor
      ? []
      : [
          <input
            id="standards-checkbox"
            key="standardInput"
            checked={this.props.standard}
            type="checkbox"
            onChange={(event) => c.alignToStandardChanged(event.target.checked)}
          />,
          <label key="standardsLabel" htmlFor="standards-checkbox">
            {translate('Align quiz to standard')}
          </label>,
        ];
    return (
      <div key="standardContainer" className="standard-container form">
        <div id="standard-input-container" key="standardInputContainer">
          {renderLegacyCheckbox}
        </div>
        {newStandard}
      </div>
    );
  }
}
